// インライン化したい共通 style
export const inlineDefaultCssString = `
<style>
div, table, tbody, tr, td,
em, strong, span, code, sub, sup, p {
  color: inherit;
}

table {
  border-collapse: separate;
  border-spacing: 0;
}

p {
  margin: 0;
}

em {
  font-style: italic;
}

h1, h2, h3, h4 {
  margin: 0;
  font-weight: inherit;
  font-size: inherit;
}

a {
  text-decoration: none;
}
</style>
`
